import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchTerminals} from '../actions/terminal'
import {fetchSettings} from '../actions/setting'
import {fetchOsSettings} from '../actions/ossetting'
import {fetchManufacturers} from '../actions/pcspec'
import {fetchModels} from '../actions/pcspec'
import TerminalNew from '../components/TerminalNew';

const mapStateToProps = state => {
  const { terminal } = state
  const { setting } = state
  const { ossetting } = state
  const { pcspec } = state
  const {
    isFetching,
    lastUpdated,
    items,
    totalRows
  } = terminal || {
    isFetching: true,
    items: []
  }

  const usersMaster = setting.items || [];
  const ositems = ossetting.items || [];
  const manufacturers = pcspec.manufacturers || ['AOPEN Inc.', 'Dell Inc.', 'Hewlett-Packard', 'HP'];
  const models = pcspec.models || [];

  return {
    items,
    isFetching,
    lastUpdated,
    totalRows,
    usersMaster,
    ositems,
    manufacturers,
    models
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getTerminals: fetchTerminals,
      getSettings: fetchSettings,
      getOsSettings: fetchOsSettings,
      getManufacturers: fetchManufacturers,
      getModels: fetchModels
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(TerminalNew)
